import WelcomeWidget from "@core/ts-digital-portal-widgets/WelcomeWidget";
import TenantInfoWidget from "@core/ts-digital-portal-widgets/TenantInfoWidget";

const CoreIslandWidgetFactory = (widgetName: string, widgetProps: any) => {
    switch (widgetName.toLowerCase()) {
        case "core::welcome":
            return <WelcomeWidget {...widgetProps} />;
        case "core::tenant_info":
            return <TenantInfoWidget {...widgetProps} />;
        default:
            return null;
    }
};

export default CoreIslandWidgetFactory;
